module.exports = __webpack_public_path__ + "static/media/m2uIcon.93a37946.svg";